import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { getS3Object } from '../utils/myKadImg';
import { getCompletedIn } from '../utils/time';

import { authenticateCurrentUser } from '../redux/authenticate/actions';
import { sendReportEmail } from '../redux/email/actions';
import { runCheck } from '../redux/list/actions';
import * as emailStatus from '../redux/email/status';
import * as runCheckStatus from '../redux/list/status';
import * as actions from '../redux/list/actions';
import { getSingleCheck } from '../redux/singleCheck/actions';
import * as singleCheckStatus from '../redux/singleCheck/status';
import { flashMessage } from '../redux/flash/actions';
import { resolve } from '../redux/resolve/actions';
import * as resolveStatus from '../redux/resolve/status';

import Date from '../components/Date';
import Status from '../components/Status';
import ListText from '../components/ListText';
import ListCollapse from '../components/ListCollapse';
import Image from '../components/Image';
import Modal from '../components/Modal';
import Identity from '../components/Identity';
import GetSingle from '../components/GetSingle';
import Value from '../components/Value';
import Logo from '../components/Logo';

import './ListItems.css';

const REFRESH_TIMER = 2500;
const REFRESH_TIMER_SLOW = 10000;

export default class CheckVerifyListItems extends Component {
  static propTypes = {
    checkVerifications: PropTypes.array,
    icBack: PropTypes.string,
    icFront: PropTypes.string,
    reveal: PropTypes.string,
  }

  static defaultProps = {
    checkVerifications: [],
    icBack: '',
    icFront: '',
    reveal: '',
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      reveal: props.reveal,
      images: [],
      waitedTime: 0,
      showModal: false,
      showRunCheckModal: false,
      showResolveModal: false,
      showLoadModal: false,
    };
  }

  async componentDidMount() {
    await this.loadImages();
  }

  componentWillUnmount() {
    this.loadImages();
    this.clearTimer();
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.checkVerifications ||
      this.props.checkVerifications.icFront !== nextProps.checkVerifications.icFront ||
      this.props.checkVerifications.icBack !== nextProps.checkVerifications.icBack
    ) {
      this.loadImages();
    }
    if (nextProps.reveal !== this.props.reveal) {
      this.setState({ reveal: nextProps.reveal });
    }
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async loadImages() {
    await this.setStateAsync({ loadingImages: true });
    const { store } = this.context;
    const { checkVerifications } = this.props;
    const token = await store.dispatch(authenticateCurrentUser());
    let images;
    try {
      const runImages = [];
      checkVerifications.forEach((obj, idx) => {
        if (obj.icFront) {
          runImages.push(getS3Object(obj.icFront, 'icFront', token));
        }
        if (obj.icBack) {
          runImages.push(getS3Object(obj.icBack, 'icBack', token));
        }
      });
      images = await Promise.all(runImages);
    } catch (e) {
      return;
    }
    await this.setStateAsync({
      images,
      loadingImages: false,
    });
  }

  clearTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
      }
    }

  handleSelect = async (value) => {
    this.setState({value})
  }

  handleOpenModal = (e, obj) => {
    e.preventDefault();
    if(e.currentTarget.id === 'sendResult') {
      this.setState({
        showModal: this.state.showModal === obj.checkID ? null : obj.checkID,
      });
      return;
    }
    if(e.currentTarget.id === 'runCheck') {
      this.setState({
        showRunCheckModal: this.state.showRunCheckModal === obj.checkID ? null : obj.checkID,
      });
      return;
    }
    if(e.currentTarget.id === 'resolve') {
      this.setState({
        showResolveModal: this.state.showResolveModal === obj.checkID ? null : obj.checkID,
      });
      return;
    }
  }

  handleCloseModal = (event) => {
    event.preventDefault();
    this.setState({ showModal: false, showRunCheckModal: false, showResolveModal: false });
  }

  async Resolve(obj) {
    await this.setStateAsync({ showResolveModal: false, showLoadModal: this.state.showLoadModal === obj.checkID ? null : obj.checkID });
    const { store } = this.context;
    const body = {
      checkID: obj.checkID,
      userID: obj.userID,
    };
    const res = await store.dispatch(resolve(body));
    if (res === resolveStatus.RESOLVE_STATUS_OK) {
      store.dispatch(flashMessage(`Successfully resolved ${obj.name}`, 'notify'));
      this.setStateAsync({ showLoadModal: false });
      this.getSingleCheck(obj);
      return;
    }
    this.setStateAsync({ showLoadModal: false });
    store.dispatch(flashMessage(`Fail to resolve ${obj.name}`, 'error'));
  }

  mobileVerification = (data) => {
    if (data === false) {
      return (<ListText fail textColor>Mobile: False</ListText>);
    }
    return (<ListText success>Mobile: True</ListText>);
  }

  icVerification = (data) => {
    if (data === false) {
      return (<ListText fail textColor>NRIC: False</ListText>);
    }
    return (<ListText success>NRIC: True</ListText>);
  }

  ocrVerification = (data) => {
    if (data) {
      if (data === "OCR_VERIFY_SUCCEED") {
        return <ListText success>OCR: Success</ListText>;
      }
      if (data === "OCR_VERIFY_PENDING") {
        return <ListText pending textColor>OCR: Pending</ListText>;
      }
    }
    return <ListText fail textColor>OCR: Not Verify</ListText>
  }

  getCronStatus = (text) => {
    switch (text) {
      case 'request_ctos_bad_request':
        return 'Bad Request'
      case 'request_ctos_failure':
        return 'Failure'
      case 'request_ctos_muliple_entities':
        return 'Multiple Entities'
      default:
      return 'Success';
    }
  }

  getMobileStatus(mobileVerified) {
    if (mobileVerified === false) {
      return (<ListText fail errorBox textColor>Mobile Not Verify</ListText>);
    } else {
      return (<ListText success>Mobile Verified</ListText>);
    }
  }

  getICStatus(mobileVerified, icVerified ) {
    if (mobileVerified === false) {
      return (<ListText inactive textColor>IC Verifications</ListText>);
    }
    if (mobileVerified === true && icVerified === false) {
      return (<ListText fail errorBox textColor>IC Not Verify</ListText>);
    } else {
      return (<ListText success>IC Verified</ListText>);
    }
  }

  getOCRStatus(icVerified, ocr) {
    if (icVerified === false) {
      return (<ListText inactive textColor>OCR Status</ListText>);
    }
    if (icVerified === true &&  ocr !== 'OCR_VERIFY_SUCCEED') {
      return (<ListText fail errorBox textColor>{ocr}</ListText>);
    } else {
      return (<ListText success>OCR Success</ListText>);
    }
  }

  getCRONOverallStatus(ocr, status) {
    if (ocr !== 'OCR_VERIFY_SUCCEED') {
      return (<ListText inactive textColor>CRON Status</ListText>);
    }
    if (ocr === 'OCR_VERIFY_SUCCEED' && status !== 'request_success') {
      return (<ListText fail errorBox textColor>CRON {this.getCronStatus(status)}</ListText>);
    } else {
      return (<ListText success>CRON {this.getCronStatus(status)}</ListText>);
    }
  }

  getManualRerun = (rerun) => {
    switch (rerun) {
      case true:
        return 'Manual Rerun by Admin'
      default:
        return null;
    }
  }

  getReveal = () => {
    this.props.onReveal(this.state.reveal);
  }

  toggleShow = (i) => {
    this.setState({
      reveal: this.state.reveal === i ? null : i
    }, () => {
      this.getReveal();
    });
  }

  async ReportEmail(obj) {
    this.setState({ showModal: false });
    const { store } = this.context;
    const body = {
      userID: obj.userID,
      checkID: obj.checkID,
      profileID: obj.profileID,
    };
    const res = await store.dispatch(sendReportEmail(body));
    if (res === emailStatus.EMAIL_STATUS_OK) {
      store.dispatch(flashMessage(`Email sent to ${obj.email}.`, 'error'));
      return;
    }
    store.dispatch(flashMessage(`Fail to email ${obj.email}.`, 'error'));
  }

  async RunCheck(obj) {
    this.clearTimer();
    await this.setStateAsync({
      showRunCheckModal: false,
      waitedTime: this.state.waitedTime + 1,
    });

    const { store } = this.context;
    const body = {
      userID: obj.userID,
      checkID: obj.checkID,
    };
    const res = await store.dispatch(runCheck(body));
    if (res === runCheckStatus.RUNCHECK_STATUS_OK) {
      store.dispatch(flashMessage(`Run check on ${obj.name} success.`, 'notify'));

      // UPDATE/REFRESH STATUS?
      this.getSingleCheck(obj);
      return;
    }
    if (res > runCheckStatus.RUNCHECK_STATUS_OK) {
      store.dispatch(flashMessage(`Fail to run check on ${obj.name}.`, 'error'));
      return;
    }

    if (
      obj.status === actions.DSR_STATUS_NEW ||
      obj.status === actions.DSR_STATUS_RECEIVED) {
      this.timer = setTimeout(() => {
        this.RunCheck(body);
      }, this.state.waitedTime >= 5 ? REFRESH_TIMER : REFRESH_TIMER_SLOW);
    }
  }

  getSingleCheck = async (obj) => {
    const { store } = this.context;
    const body = {
      userID: obj.userID,
      checkID: obj.checkID,
    };

    this.setState({
      userID: obj.userID,
      checkID: obj.checkID,
    });

    const res = await store.dispatch(getSingleCheck(body));
    const { checkID, userID } = this.state;
    if (res === singleCheckStatus.SINGLECHECK_STATUS_OK) {
      window.open(`/check/cid=${checkID}&uid=${userID}`); 
      return;
    }
    store.dispatch(flashMessage('Error getting the list. Please refresh to try again.', 'error'));
  }

  showRerun = (obj) => {
    if (obj.status === 'request_ctos_failure' || obj.status === 'request_ctos_bad_request') {
      return true;
    }
    return false;
  }

  changeText = (obj) => {
    const convert = obj.toString().toLowerCase().replace(/\s/g, '');
    return convert;
  }

  renderMatch = (obj) => {
    if (!obj.ccris.name && !obj.ccris.nric && obj.status === 'request_ctos_failure') {
     return <div className="Status error">Issue with CTOS</div>;
    }
    if (!obj.ccris.name && !obj.ccris.nric) {
      return <div className="Status error">Issue with <br /> CRON or CTOS</div>;
    }
    if (
      this.changeText(obj.ccris.name) === this.changeText(obj.name) &&
      obj.ccris.nric === obj.nric
    ) {
      return <div className="Status success">Details Match</div>;
    }
    if (
      this.changeText(obj.ccris.name) !== this.changeText(obj.name) &&
      obj.ccris.nric !== obj.nric
    ) {
      return <div className="Status error">Name and IC Not Match</div>;
    }
    if (this.changeText(obj.ccris.name) !== this.changeText(obj.name)) {
      return <div className="Status error">Name Not Match</div>;
    }
    if (obj.ccris.nric !== obj.nric) {
      return <div className="Status error">IC Not Match</div>;
    }
    return null;
  }

  render() {
    const { showLoadModal, showModal, showRunCheckModal, showResolveModal } = this.state;
    return (
      <div className="ListItems">
        {
          [].concat(this.props.checkVerifications).map((obj, i) => {
            const uploadedICFront = this.state.images.find(i => i.key === obj.icFront && i.name === 'icFront');
            const uploadedICBack = this.state.images.find(i => i.key === obj.icBack && i.name === 'icBack');
            return (
              <Row key={i}>
                <Modal
                  close={showModal === obj.checkID}
                  onClickNo={this.handleCloseModal}
                  onClickYes={() => this.ReportEmail(obj)}
                >
                  Are you sure you want to email result to <br /> {obj.name}?
                </Modal>
                <Modal
                  close={showRunCheckModal === obj.checkID}
                  onClickNo={this.handleCloseModal}
                  onClickYes={() => this.RunCheck(obj)}
                >
                  Are you sure you want to run check on <br /> {obj.name}?
                </Modal>
                <Modal
                  close={showResolveModal === obj.checkID}
                  onClickNo={this.handleCloseModal}
                  onClickYes={() => this.Resolve(obj)}
                >
                  Are you sure you want to resolve <br /> {obj.name}?
                </Modal>
                <Modal close={showLoadModal === obj.checkID}>
                  <Logo medium spin />
                </Modal> 
              <Row className="row-eq-height">
                <Col className="indexCol">{i+1}</Col>
                <Col className="createdAt">
                  <GetSingle type="check" object={obj}>
                    <Date>{obj.createdAt}</Date>
                  </GetSingle>
                </Col>
                <Col xs={2}>
                  <GetSingle type="profile" object={obj}>{obj.name}</GetSingle> <br/>
                  <Identity type={1} identity={`${obj.nric}`} /> <br/>
                </Col>
                <Col xs={2}>
                  {obj.ccris ? obj.ccris.name || 'n/a' : 'n/a'} <br />
                  <Identity type={1} identity={`${obj.ccris ? obj.ccris.nric || 'n/a' : 'n/a'}`} />
                </Col>
                <Col xs={2}>
                  <Status>{obj.status}</Status>
                </Col>
                <Col xs={2}>
                  {this.renderMatch(obj)} <br />
                  {this.getManualRerun(obj.manualRerun)}
                </Col>
                <Col className="actionCol">
                  <button className="buttonLink" onClick={() => this.toggleShow(obj.checkID)}>
                    {this.state.reveal === obj.checkID ? 'Hide Details' : `View Details`}
                  </button>
                  {
                    this.showRerun(obj) &&
                      <button id="runCheck" className="buttonLink" onClick={(e) => this.handleOpenModal(e, obj)}>
                        Rerun Check
                      </button>
                  }
                  {
                    obj.status === "request_ctos_bad_request" &&
                    obj.ccris.name &&
                    obj.ccris.totalCommitmentCents &&
                    <button id="resolve" className="buttonLink" onClick={(e) => this.handleOpenModal(e, obj)}>
                        Resolve Check
                      </button>
                  }
                  {
                    obj.status === 'request_success' &&
                      <button id="sendResult" className="buttonLink" onClick={(e) => this.handleOpenModal(e, obj)}>
                        Email Result
                      </button>
                  }
                  <a className="buttonLink" href={`mailto:${obj.email}?Subject=[DSR-PG]`} target="_top">
                    Contact User
                  </a>
                </Col>
              </Row>
              <ListCollapse reveal={this.state.reveal === obj.checkID}>
                  <Row>
                    <Col xs={6}>
                      <table className="imgTable">
                        <tbody>
                          <tr><td><b>IC Images</b></td></tr>
                          <tr>
                            <td>
                              {
                                this.props.checkVerifications && uploadedICFront ?
                                <Image src={uploadedICFront ? uploadedICFront.body : null} alt="icFront" loading={this.state.loadingImages}/>
                                : 'No Upload IC Front'
                              }
                            </td>
                            <td>
                              {
                                this.props.checkVerifications && uploadedICBack ?
                                <Image src={uploadedICBack ? uploadedICBack.body : null} alt="icBack" loading={this.state.loadingImages}/>
                                : 'No Upload IC Back'
                              }
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                    <Col xs={3}>
                      <p>
                        <b>Completion Time</b>:
                        {obj.isCompleted ? <Date time>{obj.completedAt}</Date> : 'Credit Check Incomplete'}
                      </p>
                      <b><code>Time Taken</code></b>: {getCompletedIn(obj.completedAt, obj.createdAt)} <br/>
                      <b><code>isCompleted</code></b>: {obj.isCompleted ? 'True' : 'False'}<br />
                    </Col>
                    <Col xs={3}>
                      <p><b>Contact Details</b>:</p>
                      <b><code>Mobile</code></b>:{obj.mobile} <br/>
                      <b><code>Email</code></b>:{obj.email}
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={5}><b>IDs</b>:</Col>
                    <Col xs={7}><b>Verification Details</b>:</Col>
                  </Row>
                  <Row className="row-eq-height">
                    <Col xs={5}>
                      <b>Track ID</b>: {obj.trackID} <br/>
                      <b>Check ID</b>: {obj.checkID} <br/>
                      <b>User ID</b>: {obj.userID} <br/>
                      <b>Profile ID</b>: {obj.profileID} <br/>
                      <b>Request ID</b>: {obj.ccris ? obj.ccris.requestID : 'N/A'} <br/>
                    </Col>
                    <Col xs={2}>
                      <div className="verificationsColumn">
                        <ul>
                          {this.mobileVerification(obj.mobileVerified)}
                          {this.icVerification(obj.icVerified)}
                          {this.ocrVerification(obj.ocrStatus)}
                        </ul>
                      </div>
                    </Col>
                    <Col xs={2}>
                      <ul>
                        {this.getMobileStatus(obj.mobileVerified)}
                        {this.getICStatus(obj.mobileVerified, obj.icVerified)}
                        {this.getOCRStatus(obj.icVerified, obj.ocrStatus)}
                        {this.getCRONOverallStatus(obj.ocrStatus, obj.status)}
                      </ul>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <b>CCRIS Info</b>:
                      <span className="inline"><b>Name:</b> { obj.ccris && obj.ccris.name }</span>
                      <span className="inline"><b>MyKad Number:</b> <Identity type={1} identity={obj.ccris ? `${obj.ccris.nric}` : ''} /></span>
                    </Col>
                    <Col xs={2}>
                      <b>
                        { obj.ccris ? <code>{obj.ccris.carLoanCount}</code>: ''}
                        Car Loan Amount
                      </b>:<br />
                      <Value money>{obj.ccris && obj.ccris.carLoanAmount}</Value><br />
                    </Col>

                    <Col xs={2}>
                      <b> 
                        { obj.ccris ? <code>{obj.ccris.creditCardLoanCount}</code>: ''}
                        Credit Card Amount
                      </b>:<br />
                      <Value money>{obj.ccris && obj.ccris.creditCardLoanAmount}</Value> <br />
                    </Col>

                    <Col xs={2}>
                      <b>
                        { obj.ccris ? <code>{obj.ccris.homeLoanAmount}</code>: ''}
                        Home Loan Amount
                        </b>:<br />
                      <Value money>{obj.ccris && obj.ccris.homeLoanAmount}</Value> <br />
                    </Col>

                    <Col xs={2}>
                      <b>
                        { obj.ccris ? <code>{obj.ccris.overdraftLoanCount}</code>: ''}
                        Overdraft Loan Amount
                      </b>:<br />
                      <Value money>{obj.ccris && obj.ccris.overdraftLoanAmount}</Value> <br />
                    </Col>

                    <Col xs={2}>
                      <b>
                      { obj.ccris ? <code>{obj.ccris.personalLoanCount}</code>: ''}
                        Personal Loan Amount
                        </b>:<br />
                      <Value money>{obj.ccris && obj.ccris.personalLoanAmount}</Value> <br />
                    </Col>

                    <Col xs={2}>
                      <b>Total Commitment</b>:<br />
                      <Value money>{obj.ccris && obj.ccris.totalCommitmentCents}</Value> <br />
                    </Col>
                  </Row>
                </ ListCollapse>
              </Row>
            )
          })
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckVerifyListItems.jsx